// Customer detail constants — extracted from CustomerDetail.jsx

export const STATES = ['NEW_LEAD','SALES_REQ_APP','APPLICATION_SENT','ACCOUNTING_MORE_INFO','ACCOUNTING_APPROVED','CONTRACT_SENT','CONTRACT_SIGNED'];

export const STATE_COLORS = {
  NEW_LEAD: 'text-[var(--text-muted)] bg-[var(--surface)] border-[var(--border)]',
  SALES_REQ_APP: 'text-blue-400 bg-blue-900/20 border-blue-800/50',
  APPLICATION_SENT: 'text-orange-400 bg-orange-900/20 border-orange-800/50',
  ACCOUNTING_MORE_INFO: 'text-amber-400 bg-amber-900/20 border-amber-800/50',
  ACCOUNTING_APPROVED: 'text-teal-400 bg-teal-900/20 border-teal-800/50',
  DECLINED: 'text-[var(--error)] bg-[var(--error-muted)] border-[var(--error)]',
  CONTRACT_SENT: 'text-cyan-400 bg-cyan-900/20 border-cyan-800/50',
  CONTRACT_SIGNED: 'text-[#57EB31] bg-[#57EB31]/10 border-[#57EB31]/40',
};

export const STATE_LABELS = {
  NEW_LEAD: 'NEW LEAD',
  SALES_REQ_APP: 'SALES REQ APP',
  APPLICATION_SENT: 'APPLICATION SENT',
  ACCOUNTING_MORE_INFO: 'ACCOUNTING MORE INFO',
  ACCOUNTING_APPROVED: 'ACCOUNTING APPROVED',
  DECLINED: 'DECLINED',
  CONTRACT_SENT: 'CONTRACT SENT',
  CONTRACT_SIGNED: 'CONTRACT SIGNED',
};

export const TRUCK_STATUS_COLORS = {
  active: 'text-[var(--success)] border-[var(--success)] bg-[var(--success-muted)]',
  repair_in_progress: 'text-[var(--warning)] border-[var(--warning)] bg-[var(--warning-muted)]',
  inactive: 'text-[var(--text-muted)] border-[var(--border)] bg-[var(--surface)]',
};

export const TENANT_BADGES = {
  MM: { label: 'MM', color: 'text-emerald-400 bg-emerald-900/20 border-emerald-700/50', fullName: 'Millennials Maintenance' },
  MT: { label: 'MT', color: 'text-violet-400 bg-violet-900/20 border-violet-700/50', fullName: 'MT Tenant' },
};
